// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfh_a bib_bk bib_bl bib_bo","SwipeLeftToClose--animating":"bfh_b"};